import React, { useEffect, useState } from 'react';
import '../css/Intro.css';
import bgImage from '../css/img/clean_background.png';
import logoImage from '../css/img/Main_Logo.png';
import IntroHeader from './IntroHeader';

function IntroPage() {
  const [showTitle, setShowTitle] = useState(false);
  const [showDesc, setShowDesc] = useState(false);
  const [showLogo, setShowLogo] = useState(false);

  useEffect(() => {
    // 1. h1 타이틀 페이드인
    const titleTimer = setTimeout(() => setShowTitle(true), 800); // 0.5초 후 타이틀
    // 2. p 설명 페이드인
    const descTimer = setTimeout(() => setShowDesc(true), 1600); // 타이틀 후 1.3초 뒤 설명
    // 3. 로고 페이드인
    const logoTimer = setTimeout(() => setShowLogo(true), 3000); // 설명 후 1.2초 뒤 로고

    return () => {
      clearTimeout(titleTimer);
      clearTimeout(descTimer);
      clearTimeout(logoTimer);
    };
  }, []);

  return (
    <>
      <IntroHeader />
      <div className="intro-container">
        <div className="neon-bg" style={{ backgroundImage: `url(${bgImage})` }}></div>
        <div className="intro-text">
          <h1 className={`intro-text-title ${showTitle ? 'fade-in' : ''}`}>
            AI가 만들어낸<br />
            리듬세계<br />
            <span>AI Groove로</span><br />
            리듬을 느껴보세요
          </h1>
          <p className={`intro-text-desc ${showDesc ? 'fade-in' : ''}`}>
            싱글/멀티 지원<br />
            AI와 함께 본인이 좋아하는<br />
            음악으로 만드는 리듬세상
          </p>
        </div>
        <div className={`main-logo-wrapper ${showLogo ? 'fade-in' : ''}`}>
          <img src={logoImage} alt="AI Groove Logo" className="main-logo" />
        </div>
      </div>
    </>
  );
}

export default IntroPage;